import SMAppHelper from 'components/helpers/SMAppHelper';
import SMRailsBridge from 'lib/SMRailsBridge.js.erb';
import SMConst from 'lib/SMConst.js';

class SMMapHelper {

  static getGeocode(lat, lng, radius) {
    let geocode = "";
    if (lat && lng) {
      radius = radius || 2;
      geocode = [lat, lng, radius + "km"].join(",");
    }
    return geocode;
  }

  static getRadiusMappingTable(){
    // km
    return {
      "zoom-20": 0.05,
      "zoom-19": 0.09,
      "zoom-18": 0.16,
      "zoom-17": 0.34,
      "zoom-16": 0.65,
      "zoom-15": 1.3,
      "zoom-14": 2.8,
      "zoom-13": 5.5,
      "zoom-12": 12.3,
      "zoom-11": 21.6,
      "zoom-10": 43,
      "zoom-9" : 85,
      "zoom-8" : 170,
      "zoom-7" : 340,
      "zoom-6" : 680,
      "zoom-5" : 0,
      "zoom-4" : 0,
      "zoom-3" : 0,
      "zoom-2" : 0,
      "zoom-1" : 0,
    };
  }

  static getZoomByRadius(radius){
    radius = parseFloat(radius);
    const table = SMMapHelper.getRadiusMappingTable();
    for (let zoom in table) {
      const r = table[zoom];
      if (radius <= r) {
        const z = parseInt(zoom.split("-")[1]);
        return z > 5 ? z : this.getDefaultZoom();
      }
    }
  }

  static getRadiusByZoom(zoom){
    const table = SMMapHelper.getRadiusMappingTable();
    zoom = zoom > 5 ? zoom : SMMapHelper.getDefaultZoom();
    return table["zoom-" + zoom];
  }

  static getRadiusByViewport(vp){
    let radius = 2.0;
    if (vp) {
      let distance = parseFloat(google.maps.geometry.spherical.computeDistanceBetween(
        vp.getNorthEast(),
        vp.getSouthWest()
      ));
      if (distance < 2000.0) distance = 2000.0;
      radius = distance / 1000.0 / 2.0;
    }
    return radius;
  }

  static getDefaultZoom(){
    return 14;
  }

  static getAddress(results, status){
    if (!results[0] || !results[0].address_components) return false;

    const comps = results[0].address_components.reverse();
    if (comps[0].short_name !== 'JP') return false;

    let address = {
      prefecture: '',
      city: '',
      address_1: '',
    };
    comps.forEach((comp) => {
      if (comp.types.includes(SMConst.AddressComponentType.Prefecture)) {
        address.prefecture = comp.long_name;
      } else if (comp.types.includes(SMConst.AddressComponentType.Locality)) {
        address.city = address.city.concat(comp.long_name);
      } else if (comp.types.includes(SMConst.AddressComponentType.Sublocality)) {
        address.address_1 = address.address_1.concat(comp.long_name);
      }
    });

    return address;
  }

  static googleMap(mapContainer, defaultPosition, zoom, options){
    let mapOptions = {
      scrollwheel: false,
      zoom: (typeof zoom === 'undefined') ? SMMapHelper.getDefaultZoom() : zoom,
      center: defaultPosition,
      //disableDefaultUI : 'disable',
      mapTypeControl : false,
      zoomControl: true,
      streetViewControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM
      }
    };
    if (SMAppHelper.isMobile()) mapOptions["draggable"] = false;
    mapOptions = Object.assign(mapOptions, options);
    const map = new google.maps.Map(mapContainer, mapOptions);
    const geocoder = new google.maps.Geocoder();

    return {
      map : map,
      geocoder : geocoder,
      markerImage : {
        url: SMRailsBridge.assetPath.mapIcon,
        scaledSize: new google.maps.Size(40, 56)
      },
    };
  }

  static defaultLatitude() {
    return 35.6922055;
  }

  static defaultLongitude() {
    return 139.6874118;
  }

  static defaultPosition() {
    return new google.maps.LatLng(this.defaultLatitude(), this.defaultLongitude());
  }

  static isPlaceItem(item){
    return !(item.types.length > 0 && item.types[0] == "establishment");
  }

  static sortPredictions(predictions){
    let places = [];
    let others = [];
    predictions.forEach(function(prediction) {
      if (SMMapHelper.isPlaceItem(prediction)) {
        places.push(prediction);
      } else {
        others.push(prediction);
      }
    });
    return places.concat(others);
  }

}
export default SMMapHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMMapHelper.js